import { render, staticRenderFns } from "./Accountdetailed.vue?vue&type=template&id=a6617284&scoped=true&"
import script from "./Accountdetailed.vue?vue&type=script&lang=js&"
export * from "./Accountdetailed.vue?vue&type=script&lang=js&"
import style0 from "./Accountdetailed.vue?vue&type=style&index=0&id=a6617284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6617284",
  null
  
)

export default component.exports